import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Container from '../../../components/Container/Container';
import SearchContainer from '../../../components/SearchContainer/SearchContainer';
import SearchInput from '../../../components/SearchInput/SearchInput';
import { useListManager } from '../../../contexts/list.manager';
import './ConsultaReaders.css';
import { ListReaders } from '../ListReaders/ListReaders';
import { PiSecurityCameraBold } from 'react-icons/pi';
import Button from '../../../components/Button/Button';
import Modal from 'react-modal';
import { IoClose } from 'react-icons/io5';
import { customStyles } from '../../../components/Modal/ModalComponent';
import { ReaderModel } from '../../../constants/readers-model';
import { useTheme } from '../../../contexts/theme';
import { slugify } from '../../../utils/string';
import { BiCog } from 'react-icons/bi';
import { ReadersOperationsModal } from '../../../components/ReadersOperationsModal/ReadersOperationsModal';
import ConsultaFormContainer from '../../../components/ConsultaFormContainer/ConsultaFormContainer';
import { FormReaders } from '../FormReaders/FormReaders';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/auth';

export function ConsultaReaders() {
   const { lineSelected } = useListManager();
   const { themeName } = useTheme();
   const [searchText, setSearchText] = useState("");
   const [filters, setFilters] = useState("");
   const navigate = useNavigate();
   const location = useLocation();
   const [refreshKey, setRefreshKey] = useState(0);
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const { t } = useTranslation();
   const { can } = useAuth();

   useEffect(() => {
      if (location.state?.deletedId || location.state?.refresh) {
         setRefreshKey((k) => !k);
         navigate(location.pathname, { replace: true, state: {} });
      }
   }, [location.state, navigate, location.pathname]);

   return (
      <div className="consulta-container">
         <div className="search-list-wrapper">
            <SearchContainer
               icon={<PiSecurityCameraBold size={20} />}
               title={t("equipment.ipReaders")}
               description={t("equipment.searchByName")}
               hideAddButton={true}
               aditionalButton1={
                  can?.("bravas.accessControl.reader.updateServices") ? (
                     <Button
                        className="button-white"
                        style={{ width: "230px" }}
                        icon={<BiCog size={20} />}
                        label={t("equipment.serviceConfiguration")}
                        onClick={() => navigate("/configuracoes-gerais-leitoras")}
                     />
                  ) : (
                     <></>
                  )
               }
               aditionalButton2={
                  can?.("bravas.accessControl.reader.syncUserOperation") ? (
                     <ReadersOperationsModal />
                  ) : (
                     <></>
                  )
               }
               aditionalButton3={
                  can?.("bravas.accessControl.reader.create") ? (
                     <Button
                        className="button-blue adicionar-button"
                        action="add"
                        label={t("equipment.addIpReader")}
                        onClick={() => setModalIsOpen(true)}
                     />
                  ) : (
                     <></>
                  )
               }
            >
               <SearchInput
                  value={searchText}
                  placeholder={t("equipment.searchReaders")}
                  onChange={({ target }) => setSearchText(target.value)}
                  onKeyPress={(e) =>
                     e.key === "Enter" && setFilters(searchText)
                  }
               />
            </SearchContainer>

            <Container>
               <ListReaders
                  filters={filters}
                  lineSelected={lineSelected ? true : false}
                  refreshKey={refreshKey}
               />
            </Container>
         </div>

         {lineSelected?.model && (
            <ConsultaFormContainer>
               <FormReaders
                  reader={lineSelected}
                  type="consulta"
                  model={lineSelected?.model}
               />
            </ConsultaFormContainer>
         )}

         <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            style={{
               ...customStyles,
               content: {
                  ...customStyles.content,
                  width: "650px",
                  maxWidth: "90dvw",
                  padding: "36px",
               },
            }}
            contentLabel={t("equipment.addReader")}
         >
            <div className="modal-header">
               <h2>{t("equipment.chooseReaderType")}</h2>

               <button
                  className="close-button"
                  onClick={() => setModalIsOpen(false)}
                  aria-label={t("equipment.close")}
               >
                  <IoClose />
               </button>
            </div>

            <div className="modal-body">
               <div className="buttons-reader-model-wrapper grid grid-cols-4 gap-2.5">
                  {Object.entries(ReaderModel).map(([key, value]) => (
                     <button
                        className="button-reader-model"
                        type="button"
                        key={key}
                        onClick={() =>
                           navigate(
                              `../cadastro-readers/${slugify(value.name)}`
                           )
                        }
                     >
                        {value.imageLight && (
                           <img
                              src={
                                 themeName.name === "classic"
                                    ? value.imageLight
                                    : value.imageDark
                              }
                              alt={value.name}
                           />
                        )}

                        <span>{value.name}</span>
                     </button>
                  ))}
               </div>
            </div>
         </Modal>
      </div>
   );
}